/**
 * Strip the **double-asterisk** accent markers the Designer uses for cover/cta
 * title emphasis. Render contexts that don't interpret these as accent colour
 * (operator chrome — topic-title displays, NextStep rail, kanban cards,
 * filename slugs) should show the inner text plain rather than the literal
 * asterisks.
 */
export function stripBoldMarkers(text: string): string {
  return text.replace(/\*\*([^*]+)\*\*/g, '$1');
}

/**
 * YIQ luminance test. Mirrors backend/frontend SlidePreview helper so brand-kit
 * UI can warn the operator when a chosen background colour will trigger the
 * slide renderer's dark-mode rendering path.
 */
export function isDarkColor(hex: string): boolean {
  const clean = hex.replace('#', '').slice(0, 6);
  if (!/^[0-9a-fA-F]{6}$/.test(clean)) return false;
  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 128;
}
